import { Box, FontSizeOptions, ModBox, TextNew } from '@jfs/ui-new'
import { FlatList } from 'react-native'
import { styles } from './styles'
import { itemSelected } from './types'
interface RadioButtonDropdownInterface {
  data: any
  isExportType: boolean
  onDropdownItemPress: (itemSelected: itemSelected) => void
  selectedValue?: string
  fontSize?: FontSizeOptions | number
  maxHeight?: number
}

const ListItem = ({ item, index, onDropdownItemPress, fontSize, selectedValue, length }) => {
  return (
    <Box
      {...styles.defaultDropdown}
      onPress={(_evt: any) => {
        onDropdownItemPress(item)
      }}
      testID={`defaultDropDown${index}`}
      borderBottomWidth={index === length - 1 ? 0 : 1}>
      <TextNew {...styles.defaultTextStyle} fontSize={fontSize} color={selectedValue === item.value ? 'BLUE' : 'BLACK'}>
        {item?.value ?? ''}
      </TextNew>
    </Box>
  )
}

export const DefaultDropDown = ({
  data,
  isExportType,
  onDropdownItemPress,
  selectedValue = '',
  fontSize,
  maxHeight,
}: RadioButtonDropdownInterface) => {
  return (
    <ModBox show={!isExportType} maxHeight={maxHeight}>
      <FlatList
        data={data}
        renderItem={({ item, index }) => (
          <ListItem
            item={item}
            index={index}
            onDropdownItemPress={onDropdownItemPress}
            selectedValue={selectedValue}
            fontSize={fontSize}
            length={data?.length}
          />
        )}
        keyExtractor={(item) => item.id}
      />
    </ModBox>
  )
}
